import React from 'react';
import { Select } from "../../components/Select/Select";
import { DRILL_NAVIGATION_BACKGROUND_COLOR } from "../../constants/styles";
import { makeStyles } from "../../styles/index";
import { SubjectItem } from "./components/SubjectItem";
import { TransitionDrillButton } from "./components/TransitionDrillButton";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'block',
        position: 'relative',
        height: '100%',
        width: 236,
        backgroundColor: DRILL_NAVIGATION_BACKGROUND_COLOR,
    },
    selectGrade: {
        display: 'block',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2, 0, 2, 2),
    },
    transitionButtonBase: {
        position: 'absolute',
        bottom: 0,
    },
}); }, { name: 'SnDrillNavigation' });
/**
 * コース一覧の左側に表示され、表示する学年や教科の選択ができるコンポーネント
 */
export var DrillNavigation = function (_a) {
    var currentGrade = _a.currentGrade, currentSubject = _a.currentSubject, _b = _a.displayTransitionDrillButton, displayTransitionDrillButton = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, selectionGrades = _a.selectionGrades, selectionSubjects = _a.selectionSubjects, onChangeGrade = _a.onChangeGrade, onChangeSubject = _a.onChangeSubject;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.selectGrade },
            React.createElement(Select, { dense: true, disabled: disabled, 
                // 6アイテム分の高さ + 境界線の幅(2px ×2)を指定
                maxPopupHeight: 244, selectItems: selectionGrades, value: currentGrade, onChange: function (value) { return onChangeGrade(Number(value)); } })),
        React.createElement("div", null, selectionSubjects.map(function (_a) {
            var id = _a.id, Icon = _a.Icon, name = _a.name, color = _a.color;
            return (React.createElement(SubjectItem, { key: id, disabled: disabled, selected: id === currentSubject, subject: id, subjectColor: color, SubjectIcon: Icon, subjectName: name, onClickSubject: onChangeSubject }));
        })),
        displayTransitionDrillButton && React.createElement(TransitionDrillButton, null)));
};
